import React from 'react';

import { formatRating } from '../../../utils/formatRating';
import type { RatingPillProps } from './types';
import * as styles from './RatingPill.styles';

export function RatingPill({ rating }: RatingPillProps) {
  if (!Number.isFinite(rating)) {
    return null;
  }

  return <span css={styles.pill(rating)}>{`${formatRating(rating)}/5`}</span>;
}
